import { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { formatCents } from '../../utils/formatters';

export default function RunningTotalsWidget({ shopId, roNumber, invoiceLineSumCents, checkAmountCents }) {
  const [tekmetric, setTekmetric] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!shopId || !roNumber || !roNumber.trim()) {
      setTekmetric(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    api.tekmetricRoPartsTotal(shopId, roNumber.trim())
      .then(d => { if (!cancelled) { setTekmetric(d); setLoading(false); } })
      .catch(() => { if (!cancelled) { setTekmetric(null); setLoading(false); } });
    return () => { cancelled = true; };
  }, [shopId, roNumber]);

  const tekmetricCents = tekmetric?.parts_subtotal_cents || 0;
  const diffVsCheck = invoiceLineSumCents - checkAmountCents;
  const diffVsTekmetric = invoiceLineSumCents - tekmetricCents;

  const cell = (label, valueCents, sub) => (
    <div className="flex-1 min-w-0">
      <div className="text-[10px] uppercase tracking-wider text-[var(--color-warm-500)] font-bold">{label}</div>
      <div className="text-[18px] font-bold text-[var(--color-warm-900)] tabular-nums mt-1">
        {valueCents == null ? '—' : formatCents(valueCents)}
      </div>
      {sub && <div className="text-[11px] text-[var(--color-warm-500)] mt-0.5">{sub}</div>}
    </div>
  );

  const diffColor = (cents) =>
    Math.abs(cents) < 100
      ? 'text-[var(--color-recovery-700)]'
      : 'text-[var(--color-action-700)]';

  return (
    <div className="rounded-lg border border-[var(--color-warm-200)] bg-[var(--color-cream-100)] p-4">
      <div className="flex items-end gap-4">
        {cell('Invoice lines', invoiceLineSumCents)}
        {cell('Tekmetric RO',
          loading ? null : (tekmetric?.found ? tekmetricCents : null),
          tekmetric == null
            ? 'Enter RO# to load'
            : (tekmetric?.found ? `${tekmetric.parts_count} parts` : 'Not found in Tekmetric')
        )}
        {cell('Check amount', checkAmountCents)}
      </div>

      <div className="grid grid-cols-2 gap-2 mt-3 pt-3 border-t border-[var(--color-warm-200)] text-[12px]">
        <div className="flex items-center justify-between">
          <span className="text-[var(--color-warm-600)]">Invoice − Check:</span>
          <span className={`font-bold tabular-nums ${diffColor(diffVsCheck)}`}>
            {diffVsCheck > 0 ? '+' : ''}{formatCents(diffVsCheck)}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-[var(--color-warm-600)]">Invoice − Tekmetric:</span>
          <span className={`font-bold tabular-nums ${tekmetric?.found ? diffColor(diffVsTekmetric) : 'text-[var(--color-warm-400)]'}`}>
            {tekmetric?.found ? `${diffVsTekmetric > 0 ? '+' : ''}${formatCents(diffVsTekmetric)}` : '—'}
          </span>
        </div>
      </div>
    </div>
  );
}
